import nonccdb from "./NonCreditContractsDownloadBusinessClientSchema";


const form = {
    title: "Carga Contratos / Firmas",
    displayName: 'NonCreditContractsUploadBusinessClient',
    page: 'non-credit-contracts-business-client',
    determineCanEdit: ({ currentCase }) => (true),
};


form.schema = {
    title: "Solicitud de Vinculación Cliente Empresa",
    type: "object",
    properties: {
        "dct": nonccdb.schema.properties.dct,
        "dfp": {
            title: "Documentos firmados Puesto",
            type: "object",
            properties: {
                "tarjetaFirmaPuesto": {
                    title: "Registro Firma Persona Jurídica",
                    type: "number",
                },
                "informeInversionistaPuesto": {
                    title: "Informe Perfil de Inversionista",
                    type: "number",
                },
                "contratoMarcoPuesto": {
                    title: "Contrato Marco",
                    type: "number",
                },
                "contratoCuentaAperturaPuesto": {
                    title: "Contrato Apertura Cuenta",
                    type: "number",
                },
                "cartaAutoApertCuentaPuesto": {
                    title: "Carta Autorización Apertura Cuenta",
                    type: "number",
                },
                "formClientePuesto": {
                    title: "Formulario Conozca su Cliente",
                    type: "number",
                },
                "formW8BenPuesto": {
                    title: "Formulario de MONEYLINE Comercial",
                    type: "number",
                },
                "formFormularioMoneylineComercialPuesto": {
                    title: "Formulario W8-BEN-E",
                    type: "number",
                },
                "formFormularioW8FideicomisosPuesto": {
                    title: "Formulario W-8IMY que aplica para clientes que son Fondos de Inversión o Fideicomisos",
                    type: "number",
                },
                "formFormularioW9Puesto": {
                    title: "IRS W-9(SP)",
                    type: "number",
                },
            },
            required: [
            ]
        },
        "dfs": {
            title: "Documentos firmados SAFI",
            type: "object",
            properties: {
                "tarjetaFirmaSafi": {
                    title: "Registro Firma Persona Jurídica",
                    type: "number",
                },
                "informeInversionistaSafi": {
                    title: "Informe Perfil de Inversionista",
                    type: "number",
                },
                "contratoMarcoSafi": {
                    title: "Contrato Marco",
                    type: "number",
                },
                "formClienteSafi": {
                    title: "Formulario Conozca su Cliente",
                    type: "number",
                },
                "formW8BenSafi": {
                    title: "Formulario W8-BEN-E",
                    type: "number",
                },
                "formDesignacionCuentaBancariaSAFI": {
                    title: "Formulario de cuenta autorizada por el cliente para pago de rescates (Designación de cuenta bancaria SAFI)",
                    type: "number",
                },
                "formFormularioMoneylineComercialSAFI": {
                    title: "Formulario de MONEYLINE Comercial",
                    type: "number",
                },
                "formFormularioW8FideicomisosSAFI": {
                    title: "Formulario W-8IMY que aplica para clientes que son Fondos de Inversión o Fideicomisos",
                    type: "number",
                },
                "formFormularioW9Safi": {
                    title: "IRS W-9(SP)",
                    type: "number",
                },
            },
            required: [
            ]
        },
        "dfb": {
            title: "Documentos Firmados Banco",
            type: "object",
            properties: {
                "tarjetaFirmaBanco": {
                    title: "Registro Firma Persona Jurídica",
                    type: "number",
                },
                "formClienteBanco": {
                    title: "Formulario Conozca su Cliente",
                    type: "number",
                },
                "formW8BenBanco": {
                    title: "Formulario W8-BEN-E",
                    type: "number",
                },
                "solicitudPrestamo": {
                    title: "Solicitud de Préstamo",
                    type: "number",
                },
                "formContratoMarcoProductosBanco": {
                    title: "Contrato Marco de Productos y Servicios del Banco",
                    type: "number",
                },
                "formFormularioMoneylineComercialBanco": {
                    title: "Formulario de MONEYLINE Comercial",
                    type: "number",
                },
                "formFormularioW8FideicomisosBanco": {
                    title: "Formulario W-8IMY que aplica para clientes que son Fondos de Inversión o Fideicomisos",
                    type: "number",
                },
                "formFormularioAperturaCertificado": {
                    title: "Formulario Apertura de Certificado",
                    type: "number",
                },
                "formFormularioW9Banco": {
                    title: "IRS W-9(SP)",
                    type: "number",
                },
            },
            required: [
            ]
        },
        // "sso": {
        //     title: "Soporte Sujeto Obligado",
        //     type: "object",
        //     properties: {
        //         "soporteSujetoObligadoFile": {
        //             title: "Soporte de Sujeto Obligado No Financiero Personal",
        //             type: "number",
        //         },
        //     }
        // }
    },
    required: [],
};



form.uiSchema = {
    "dct": nonccdb.uiSchema.dct,
    dfp: {
        "classNames": "personalNonCCD-upload",
        "ui:field": "HideObjectField",
        "tarjetaFirmaPuesto": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.registroFirmaPersJuridicasPuesto" } },
        "informeInversionistaPuesto": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.informeInversionistaPuesto" } },
        "contratoMarcoPuesto": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.contratoMarcoPuesto" } },
        "contratoCuentaAperturaPuesto": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.contratoCuentaCelvadom" } },
        "cartaAutoApertCuentaPuesto": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.cartaCuentaCelvadom" } },
        "formClientePuesto": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.formularioClientePuesto" } },
        "formW8BenPuesto": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.formularioW8BenePuesto" } },     
        "formFormularioMoneylineComercialPuesto": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.formularioMoneylineComercialPuesto" } },   
        "formFormularioW8FideicomisosPuesto": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.formularioW8FideicomisosPuesto" } },      
        "formFormularioW9Puesto": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.formularioW9Puesto" } },
    },
    dfs: {
        "classNames": "personalNonCCD-upload",
        "ui:field": "HideObjectField",
        "tarjetaFirmaSafi": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.registroFirmaPersJuridicasSafi" } },
        "informeInversionistaSafi": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.informeInversionistaSafi" } },
        "contratoMarcoSafi": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.contratoMarcoSafi" } },
        "formClienteSafi": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.formularioClienteSafi" } },
        "formW8BenSafi": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.formularioW8BeneSAFI" } },
        "formDesignacionCuentaBancariaSAFI": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.designacionCuentaBancariaSAFI" } },
        "formFormularioMoneylineComercialSAFI": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.formularioMoneylineComercialSAFI" } },
        "formFormularioW8FideicomisosSAFI": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.formularioW8FideicomisosSAFI" } },
        "formFormularioW9Puesto": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.formularioW9Safi" } },
    },
    dfb: {
        "classNames": "personalNonCCD-upload",
        "ui:field": "HideObjectField",
        "tarjetaFirmaBanco": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.registroFirmaPersJuridicasBanco" } },
        "formClienteBanco": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.formularioClienteBanco" } },
        "formW8BenBanco": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.formularioW8BeneBanco" } },
        "solicitudPrestamo": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.solicitudPrestamo" } },
        "formContratoMarcoProductosBanco": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.contratoMarcoProductosBanco" } },
        "formFormularioMoneylineComercialBanco": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.formularioMoneylineComercialBanco" } },
        "formFormularioW8FideicomisosBanco": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.formularioW8FideicomisosBanco" } },
        "formFormularioW9Banco": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.formularioW9Banco" } },
    },
    // sso: {
    //     "classNames": "personalNonCCD-upload",
    //     "ui:field": "HideObjectField",
    //     "soporteSujetoObligadoFile": { "ui:field": "FileField", "joli:hideAttr": { "ifEmpty": "dct.formularioSujetoObligado" } },
    // }
};

form.objectMap = {
    ...nonccdb.objectMap,

    "caseLoanInfo.loanApplicationFileId": "dfb.solicitudPrestamo",
    //    puesto
    "clients[0].businessClientDueDiligenceReport.puestoCardSignatureFileId": "dfp.tarjetaFirmaPuesto",
    "clients[0].businessClientDueDiligenceReport.puestoInvestorReportFileId": "dfp.informeInversionistaPuesto",
    "clients[0].businessClientDueDiligenceReport.puestoMarkContractFileId": "dfp.contratoMarcoPuesto",
    "clients[0].businessClientDueDiligenceReport.puestoAccountContractFileId": "dfp.contratoCuentaAperturaPuesto",
    "clients[0].businessClientDueDiligenceReport.puestoAccountOpeningLetterFileId": "dfp.cartaAutoApertCuentaPuesto",
    "clients[0].businessClientDueDiligenceReport.puestoClientFormFileId": "dfp.formClientePuesto",
    "clients[0].businessClientDueDiligenceReport.puestoW8BenFileId": "dfp.formW8BenPuesto",
    "clients[0].businessClientDueDiligenceReport.formularioMoneylineComercialPuestoFileId": "dfp.formFormularioMoneylineComercialPuesto",
    "clients[0].businessClientDueDiligenceReport.formularioW8FideicomisosPuestoFileId": "dfp.formFormularioW8FideicomisosPuesto",
    "clients[0].businessClientDueDiligenceReport.formularioW9PuestoFileId": "dfp.formFormularioW9Puesto",
    //    safi
    "clients[0].businessClientDueDiligenceReport.safiCardSignatureFileId": "dfs.tarjetaFirmaSafi",
    "clients[0].businessClientDueDiligenceReport.safiInvestorReportFileId": "dfs.informeInversionistaSafi",
    "clients[0].businessClientDueDiligenceReport.safiMarkContractFileId": "dfs.contratoMarcoSafi",
    "clients[0].businessClientDueDiligenceReport.safiClientFormFileId": "dfs.formClienteSafi",
    "clients[0].businessClientDueDiligenceReport.safiW8BenFileId": "dfs.formW8BenSafi",
    "clients[0].businessClientDueDiligenceReport.designacionCuentaBancariaSAFIFileId": "dfs.formDesignacionCuentaBancariaSAFI",
    "clients[0].businessClientDueDiligenceReport.formularioMoneylineComercialSAFIFileId": "dfs.formFormularioMoneylineComercialSAFI",
    "clients[0].businessClientDueDiligenceReport.formularioW8FideicomisosSAFIFileId": "dfs.formFormularioW8FideicomisosSAFI",
    "clients[0].businessClientDueDiligenceReport.formularioW9SafiFileId": "dfs.formFormularioW9Safi",

    //    banco
    "clients[0].businessClientDueDiligenceReport.bancoCardsignatureFileId": "dfb.tarjetaFirmaBanco",
    "clients[0].businessClientDueDiligenceReport.bancoClientFormFileId": "dfb.formClienteBanco",
    "clients[0].businessClientDueDiligenceReport.bancoW8BenFileId": "dfb.formW8BenBanco",
    "clients[0].businessClientDueDiligenceReport.contratoMarcoProductosBancoFileId": "dfb.formContratoMarcoProductosBanco",
    "clients[0].businessClientDueDiligenceReport.formularioMoneylineComercialBancoFileId": "dfb.formFormularioMoneylineComercialBanco",
    "clients[0].businessClientDueDiligenceReport.formularioW8FideicomisosBancoFileId": "dfb.formFormularioW8FideicomisosBanco",
    "clients[0].businessClientDueDiligenceReport.formularioW9BancoFileId": "dfb.formFormularioW9Banco",

}


export default form;